/** A project's releases: the list, making one, the version history, and imported projects. */

export default {
	releases: {
		title: "Releases",
		description:
			"Ein Release ist eine Version des Projekts, die sich nie mehr ändert: gebaut, paketiert und im Verlauf markiert. Dataspaces führen Releases aus.",
		newRelease: "Neues Release",
		empty: "Noch keine Releases.",
		emptyHint: "Erstellen Sie das erste Release, sobald sich das Projekt bauen lässt.",
		loadFailed: "Die Releases konnten nicht geladen werden.",
		latest: "Neuestes",
		by: "von {name}",
		notes: "Notizen",
		noNotes: "Keine Notizen.",
		runBy: "Ausgeführt von",
		runByNone: "Kein Dataspace führt diese Version aus.",
		dataspaceCount: "Keine Dataspaces | {n} Dataspace | {n} Dataspaces",
		commit: "Commit",
		previous: "Vorherige Version",
		tagged: "Veröffentlicht als {tag}",
		bumpLabel: {
			patch: "Patch",
			minor: "Minor",
			major: "Major",
			custom: "Eigene",
		},
		versionHistory: {
			title: "Versionsverlauf",
			all: "Alle Releases",
			empty: "Bisher wurde nichts veröffentlicht.",
		},
		create: {
			title: "Neues Release",
			previous: "Vorheriges Release: v{version}",
			first: "Das ist das erste Release des Projekts.",
			commits: "Seitdem keine Änderungen | Seitdem eine Änderung | Seitdem {n} Änderungen",
			version: "Version",
			choice: "{bump} — v{version}",
			choiceSuggested: "{bump} — v{version} (vorgeschlagen)",
			choiceHelp: {
				patch: "Korrekturen und kleine Änderungen: nichts hinzugefügt, nichts entfernt.",
				minor: "Es kam etwas hinzu. Wer das Projekt nutzt, verliert nichts.",
				major: "Etwas wurde entfernt oder umbenannt. Wer sich darauf verlässt, kann Probleme bekommen.",
			},
			custom: "Andere Version",
			customHelp:
				"Eine semantische Version, größer als das vorherige Release, etwa 1.2.0 oder 2.0.0-rc.1.",
			reasons: "Warum diese Version",
			noReasons: "Seit dem letzten Release verlangt nichts mehr als einen Patch.",
			ruleLabel: {
				breaking: "Als inkompatibel markiert",
				removal: "Entfernt",
				rename: "Umbenannt",
				addition: "Hinzugefügt",
				change: "Geändert",
			},
			titleLabel: "Titel",
			titleHelp: "Optional. Ein Name für das Release, der neben der Version angezeigt wird.",
			notesLabel: "Release-Notizen",
			notesHelp:
				"Was sich geändert hat, für alle, die das Release ausführen. Die Notizen werden zum Nachrichtentext des Release-Commits.",
			changelog: "Änderungsprotokoll",
			submit: "v{version} veröffentlichen",
			submitPlain: "Veröffentlichen",
			problem: {
				empty: "Geben Sie eine Version ein.",
				invalid: "Keine semantische Version. Verwenden Sie die Form 1.2.0.",
				notGreater: "Muss größer als v{previous} sein.",
			},
			progress: {
				preparing: "Das Release wird vorbereitet…",
				waiting: "Der laufende Build wird abgewartet…",
				building: "v{version} wird gebaut…",
				finishing: "v{version} wird committet, paketiert und markiert…",
			},
			progressNote:
				"Das kann einige Minuten dauern. Wird das Projekt währenddessen geändert, muss das Release erneut erstellt werden.",
			created: "v{version} veröffentlicht.",
			draftFailed: "Das nächste Release konnte nicht ermittelt werden.",
			buildOutput: "Build-Ausgabe",
		},
		errors: {
			buildFailed:
				"Der Build von v{version} ist fehlgeschlagen, daher wurde nichts veröffentlicht.",
			invalidVersion:
				"„{version}“ ist keine semantische Version. Verwenden Sie die Form 1.2.0.",
			notGreater: "v{version} ist nicht größer als das neueste Release.",
			exists: "v{version} wurde auf diesem Server bereits veröffentlicht oder gebaut. Wählen Sie eine andere Version.",
			conflict:
				"Das Projekt hat sich geändert, während das Release gebaut wurde, daher wurde nichts veröffentlicht. Erstellen Sie das Release erneut.",
		},
		imported: {
			badge: "Importiert — nur Releases",
			title: "Von einem anderen Server importiert",
			note: "Seine Releases können hier in einem Dataspace laufen, aber seine Quelle liegt nicht auf diesem Server, daher lässt sich darin nichts bearbeiten.",
			cardNote:
				"Hier nur durch seine Releases bekannt, die in einem Dataspace laufen können; bearbeiten lässt sich darin nichts.",
			versions: "Ausführbare Versionen",
			versionsNote:
				"Ein Dataspace dieses Projekts kann auf jede dieser Versionen eingestellt werden.",
			versionsEmpty: "Keine Version dieses Projekts kann hier laufen.",
		},
	},
};
